import React from 'react';
import { Building2, Radius as Stadium, School, Wrench, ArrowRight } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';

const categories = [
  {
    icon: Building2,
    title: 'services.categories.commercial.title',
    description: 'services.categories.commercial.description',
  },
  {
    icon: Stadium,
    title: 'services.categories.special.title',
    description: 'services.categories.special.description',
  },
  {
    icon: School,
    title: 'services.categories.institutional.title',
    description: 'services.categories.institutional.description',
  },
  {
    icon: Wrench,
    title: 'services.categories.specialized.title',
    description: 'services.categories.specialized.description',
  },
];

export function ServiceCategories() {
  const { t } = useLanguage();

  return (
    <section className="py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center">
          <h2 className="text-3xl font-extrabold text-gray-900 sm:text-4xl">
            {t('services.title')}
          </h2>
          <p className="mt-4 text-lg text-gray-600 max-w-3xl mx-auto">
            {t('services.subtitle')}
          </p>
        </div>

        <div className="mt-16 grid grid-cols-1 gap-8 sm:grid-cols-2">
          {categories.map(({ icon: Icon, title, description }) => (
            <div
              key={title}
              className="relative group bg-white p-6 rounded-lg shadow-md hover:shadow-lg transition-shadow"
            >
              <div className="absolute -inset-0.5 bg-gradient-to-r from-blue-900 to-blue-700 rounded-lg opacity-0 group-hover:opacity-100 transition-opacity" />
              <div className="relative">
                <Icon className="h-8 w-8 text-blue-900" />
                <h3 className="mt-4 text-lg font-semibold text-gray-900">{t(title)}</h3>
                <p className="mt-2 text-gray-600">{t(description)}</p>
                <a
                  href={`/services#${t(title).toLowerCase()}`}
                  className="mt-4 inline-flex items-center text-sm font-medium text-blue-900 hover:text-blue-700"
                >
                  {t('services.learnMore')}
                  <ArrowRight className="ml-1 h-4 w-4" />
                </a>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}